import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import TextField from "@material-ui/core/TextField";
import Modal from "react-bootstrap/Modal";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import { useAppDispatch, useAppSelector } from "../../useStore";
import { Spinners } from "../TableOptions";
import {
  UpdateScreeningStatus,
  reset,
} from "../../features/Applicant/applicantSlice";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import ModalHeader from "../ModalHeader";

const ScreeningUpdateModal = ({ nametitle, name, id, disabled }: any) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const {
    UpdateScreeningStatusisError,
    UpdateScreeningStatusmessage,
    UpdateScreeningStatusisLoading,
    UpdateScreeningStatusisSuccess,
  } = useAppSelector((state: { applicant: any }) => state.applicant);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);



  const [inputs, setInputs] = useState({
    comment: "",
    status: "COMPLETED",
    id: "",
  });


  useEffect(() => {
    if (UpdateScreeningStatusisError) {
      swal({
        title: "error",
        text: UpdateScreeningStatusmessage,
        icon: "error",
      });
    } else if (UpdateScreeningStatusisSuccess) {
      swal({
        title: "success",
        text: "Applicant Screening is now Completed!",
        // @ts-ignore
        icon: "success",
      });
      setShow(false);
      setInputs({
        comment: "",
        status: "",
        id: "",
      });
    }
    dispatch(reset());
  }, [
    UpdateScreeningStatusisError,
    UpdateScreeningStatusisSuccess,
    UpdateScreeningStatusmessage,
    dispatch,
    navigate,
  ]);

  const handleOnChange = (input: any, value: any) => {
    setInputs((prevState: any) => ({
      ...prevState,
      [input]: value,
    }));
  };

  useEffect(() => {
    setInputs((prevState: any) => {
      return {
        ...prevState,
        id: id,
      };
    });
  }, [inputs.id, setInputs, id]);




  const handleScreening = () => {
    // @ts-ignore

    dispatch(UpdateScreeningStatus(inputs));
  };
  return (
    <>
      <div
        onClick={() => {
          if (disabled) {
            toast.success("Screening Completed!");
          } else {
            handleShow();
          }
        }}
        className="more-button"
      >
        <Button className={disabled ? "view-job-profile more-button-disabled" : "view-job-profile update"}>
          {disabled ? "Screening Completed" : "Update Screening Status"}
        </Button>
      </div>

      <Modal show={show} onHide={handleClose}>
        <ModalHeader setShow={setShow} headerTitle={"Update Screening Status"} />
        <Modal.Body>
          <form>
            <div className="applicant-name">
              <h5>Applicant Name</h5>
              <p>{nametitle + " " + name} </p>
            </div>
            <br />
            <div className="reviewer-name">
              <h6 className="mt-4">Update Screening Status</h6>
              <TextField
                id="outlined-basic"
                value="COMPLETED"
                variant="outlined"
                className="round"
                style={{ margin: "10px 0" }}
                fullWidth
                disabled
              />

              <div className="comment mt-4">
                <h6>Comment</h6>
                <TextField
                  id="outlined-multiline-static"
                  multiline
                  fullWidth
                  type="text"
                  minRows={4}
                  variant="outlined"
                  style={{ margin: "10px 0" }}
                  value={inputs.comment}
                  onChange={(e) => handleOnChange("comment", e.target.value)}
                />
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button id="primary" onClick={handleScreening}>
            {UpdateScreeningStatusisLoading ? <Spinners size={"sm"} /> : "Send"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ScreeningUpdateModal;
